import React, { Component } from 'react';
import styled from 'styled-components';


const Error = styled.div`
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const Title = styled.h1`
    text-align: center;
`;

class SettingsError extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorFound: false,
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            errorFound: true,
        });

        console.log(error, info);
    }

    render() {
        if (this.state.errorFound) {
            return (
                <Error>
                    <Title>Възникна грешка при зареждане на настройките.</Title>
                </Error>
            );
        }
        return this.props.children;
    }
}

export default SettingsError;